import { useEffect, useState } from "react";
import ButtonComponent from "../../../../components/ButtonComponent";
import { EnviarCodigoValidacaoSenha } from "../../../../store/actions/usuario";
import { removeDots } from "../../../../helpers/removeDots";

function CodigoResetSenha({
  closeModal,
  sendCode,
  cpf,
  token,
  setToken,
  loading,
}) {
  const handleInputChange = (e) => {
    const inputValue = e.target.value;
    const numericValue = inputValue.replace(/\D/g, ""); // Remove todos os caracteres não numéricos

    setToken(numericValue);
  };

  const [contador, setContador] = useState(0);

  async function sendCodeRecovery() {
    await EnviarCodigoValidacaoSenha({ cpf: removeDots(cpf) });
    setContador(contador + 45);
  }

  useEffect(() => {
    let timer;

    if (contador > 0) {
      timer = setInterval(() => {
        setContador(contador - 1);
      }, 1000);
    }

    return () => clearInterval(timer);
  }, [contador]);

  return (
    <div style={{ flexDirection: "column", display: "flex" }}>
      <span style={styles.title}>Recebeu o código?</span>
      <span style={styles.description}>
        Enviamos um código de 6 dígitos via SMS e Email cadastrados para criar
        uma nova senha
      </span>

      <span style={{ ...styles.description, fontSize: 12, marginTop: 30 }}>
        Digite o código para recuperação de senha
      </span>

      <input
        type="text"
        style={{ ...styles.inputStyle, width: "100%" }}
        value={token}
        onChange={handleInputChange}
        placeholder="0 0 0 0 0 0"
        maxLength="6"
      />

      <span style={{ ...styles.description, fontSize: 12, marginTop: 30 }}>
        Não recebeu o código?
        <button
          style={{ ...styles.buttonTertiary, marginLeft: 10, color: "#86bfc6" }}
          onClick={() => sendCodeRecovery()}
          disabled={contador > 0} // Desabilita o button se o contador estiver ativo
        >
          {contador > 0 ? `Aguarde ${contador} segundos` : "Reenviar código"}
        </button>
      </span>

      <div
        style={{
          marginTop: 40,
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <button style={styles.buttonTertiary} onClick={() => closeModal(false)}>
          Fechar
        </button>

        <ButtonComponent disabled={loading} onClick={() => sendCode()}>
          Continuar
        </ButtonComponent>
      </div>
    </div>
  );
}

const styles = {
  title: {
    fontSize: 18,
    fontWeight: "600",
  },
  description: {
    fontSize: 14,
  },
  buttonTertiary: {
    border: "none",
    background: "transparent",
    fontWeight: "600",
    textDecorationLine: "underline",
    cursor: "pointer",
    color: "#191919",
  },
  inputStyle: {
    borderRadius: 18,
    padding: 16,
    marginTop: 15,
    border: "1px solid #bcbcbc",
    width: "70%",
    fontSize: 24,
    textAlign: "center",
  },
};

export default CodigoResetSenha;
